// packages imports
import { useFormContext, useFieldArray } from 'react-hook-form'
import ClearIcon from '@mui/icons-material/Clear'
import AddIcon from '@mui/icons-material/Add'

// components imports
import { IconButton, Button, Box, Typography } from '@mui/material'
import { CustomController } from '../../../common/CustomController'
import InfoTooltip from '../../../common/InfoTooltip'

// others
import { flexCenter } from '../../../../theme/styleConstants'
import { CustomDatePickerController } from '../../../common/CustomDatePickerRController'

const FlatFeeSpecialPaymentsForm = () => {
  const { control } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'billing.specialPayments'
  })

  return (
    <Box mt={2.5}>
      <Typography variant="h3" textTransform="uppercase" fontSize={16} fontWeight={700}>
        Special Payments
      </Typography>
      <InfoTooltip info="Additional payments that can be billed to the client on specific dates after the upfront fee and before the monthly payments start" />

      <Box mt={1.5} display="flex" flexDirection="column" gap={2}>
        {fields.map((field, index) => (
          <Box key={field.id} sx={{ ...flexCenter, gap: 1.5 }}>
            <CustomController
              fieldType="number"
              controllerName={`billing.specialPayments.${index}.amount`}
              controllerLabel={`Special Payment ${index + 1} Amount ($)`}
              dollarAdornment
              sx={{ my: 0 }}
            />
            <CustomDatePickerController
              controllerName={`billing.specialPayments.${index}.date`}
              controllerLabel={`Special Payment ${index + 1} Date`}
              minDate={new Date()}
              sx={{ my: 0 }}
            />

            <IconButton color="primary" onClick={() => remove(index)}>
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}

        <Button
          startIcon={<AddIcon />}
          size="small"
          sx={{ width: 'fit-content' }}
          onClick={() =>
            append({
              amount: '',
              date: ''
            })
          }
        >
          Add Special Payment
        </Button>
      </Box>
    </Box>
  )
}

export default FlatFeeSpecialPaymentsForm
